import axios from "axios";

const AxiosCustom = (_config, _data, headers) => {
  let config = {
    baseURL: getUrl(),
    method: "POST",
    headers: {
      ...headers,
    },
    ..._config,
    data: _data ? _data : {},
  };

  return axios(config);
};

export function getUrl() {
  let protocol = window.location.protocol;
  let hostName = window.location.hostname;

  if (
    !protocol ||
    !hostName ||
    hostName === "localhost" ||
    hostName == "http://site.pouyantech.local" ||
    hostName == "site.pouyantech.local"
  ) {
    return `https://dev-scapi.pouyatek.ir/api/v1`;
  }

  return `https://scapi.pouyanbroker.ir/scgateway/api/v1`;
  return `http://api1.pouyanbroker.ir/api/v1`;
}

export default AxiosCustom;
